export const LOAD_IMAGES = 'LOAD_IMAGES';
export const ADD_IMAGE = 'ADD_IMAGE';
export const LOAD_IMAGES_BY_BOOK_ID = 'LOAD_IMAGES_BY_BOOK_ID';
export const DELETE_IMAGES = 'DELETE_IMAGES';
export const DELETE_IMAGE = 'DELETE_IMAGE';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/images.js